import { z } from "zod";

/** Who the assistant is and how it sounds. */
export const personaSchema = z
	.object({
		assistantName: z.string().min(1).max(40).default("Shopping assistant"),
		/** One or two sentences on who the retailer is, in the retailer's words. */
		retailerDescription: z.string().max(600).default(""),
		tone: z
			.string()
			.max(200)
			.default("warm, brief and practical, like a helpful store clerk"),
	})
	.prefault({});
